/*
 * The slice's cold boot (S03 §6 step 1): the bootstrap's `modules.aichat` entry replaces the slice
 * whole. A reader the module does not admit gets no entry, and their slice is the empty one — no rows,
 * no rail row. What keeps the slice honest afterwards is `watch.ts`'s, which the boot binds later.
 */

import type { StoreApi } from "zustand"
import type { Model } from "../../../core/store/model.ts"
import type { AichatBootstrap } from "../wire/aichat.gen.ts"
import { emptyAichatSlice, sliceFromBootstrap, withAichatSlice } from "./slice.ts"

/**
 * The module's `onBootstrap`: the entry replaces the slice, and its absence empties it. Core sends a
 * module that has nothing to say to a reader as an empty object, so an entry without the new-chat
 * form's options is an absent one.
 */
export function onAichatBootstrap(payload: unknown, store: StoreApi<Model>): void {
	const boot = payload as Partial<AichatBootstrap> | undefined
	store.setState((model) =>
		withAichatSlice(
			model,
			boot?.setup === undefined ? emptyAichatSlice() : sliceFromBootstrap(boot as AichatBootstrap),
		),
	)
}
